export const ratingRanges = [
  { min: 0, max: 1.1, color: '#910000' },
  { min: 1, max: 1.6, color: '#FE0000' },
  { min: 1.6, max: 2.6, color: '#FF9A00' },
  { min: 2.6, max: 3.6, color: '#FFCA00' },
  { min: 3.6, max: 4.6, color: '#6CD240' },
  { min: 4.6, max: 5, color: '#2D9400' },
]
